<template>
  <div id="app">
    <!-- 保留状态页面 -->
    <keep-alive include="Course,Oto,Exam,PaperPackage,Assess,ErrorQues,QuesCollect,Homework">
      <router-view v-if="isRouterAlive" />
    </keep-alive>
    <app-footer />
  </div>
</template>

<script>
import appFooter from "./components/Footer";

// 打开手机端控制台
// import VConsole from 'vconsole'
// new VConsole

export default {
  components: {
    appFooter
  },
  provide() {
    return {
      // 注入根组件方法以供子级组件使用
      reload: this.reload
    };
  },
  data() {
    return {
      isRouterAlive: true
    };
  },
  methods: {
    /**
     * 获取网站配置项
     */
    async getConfig() {
      const system_webConfig = await this.$http.get(
        `/api/app/get/config/system_webConfig`
      );
      const webSetting = await this.$http.get(`/api/app/webSetting`);
      const config = {};
      Object.assign(config, system_webConfig, webSetting);
      this.$store.commit("SET_CONFIG", config);
    },
    /**
     * app内置h5设置
     */
    appSet() {
      let { app, token } = this.$pub.app_js();
      this.$store.commit("SET_APP", app);
      if (app == "ios") {
        // ios首次需要注册
        this.$pub.registerWebViewJavascriptBridge();
      }
      if (token) {
        if (token == "clear") {
          localStorage.removeItem("adminToken");
          localStorage.removeItem("user_id");
        } else {
          localStorage.setItem("adminToken", token);
        }
      }
    },
    /**
     * 刷新页面
     * */
    reload() {
      this.isRouterAlive = false;
      this.$nextTick(() => {
        this.isRouterAlive = true;
      });
    }
  },
  created() {
    this.appSet();
    this.getConfig();
    if (localStorage.adminToken) {
      this.$store.dispatch("getPerson");
    }
  },
  mounted(){
    if (!this.$pub.app_js().app) {
      this.$http.get("/api/contract/get?params=customer_chat_contract"
      ).then(res => {
        let script = document.createElement("script");
        script.type = "text/javascript";
        script.text = res.customer_chat_contract;
        document.body.appendChild(script);
      })
    }
  }
};
</script>
<style lang="scss" scoped>
#app {
  background: #fff;
  min-height: 100vh;
  box-sizing: border-box;
}
</style>
